import { ErrorMessages } from "@coxauto-ui/cxm/communications/util";
import { ResponseError } from "../interfaces/api-error";

export const getErrorMessage = (response: ResponseError): string => {
  const statusCode = response?.statusCode;

  // Return specific error message based on HTTP status code
  switch (statusCode) {
    case 400:
      return ErrorMessages.BAD_REQUEST_ERROR;
    case 401:
      return ErrorMessages.UNAUTHORIZED_ERROR;
    case 403:
      return ErrorMessages.FORBIDDEN_ERROR;
    case 404:
      return ErrorMessages.NOT_FOUND_ERROR;
    case 500:
      return ErrorMessages.SERVER_ERROR;
    case 502:
      return ErrorMessages.GATEWAY_ERROR;
    case 503:
      return ErrorMessages.SERVICE_UNAVAILABLE_ERROR;
    default:
      // For any other error code, return the generic unexpected error message
      return ErrorMessages.UNEXPECTED_ERROR;
  }
};

export const isResponseError = (
  response: unknown
): response is ResponseError => {
  return (response as ResponseError).isError;
};
